import LegalDoc from "@/components/LegalDoc";
import { GIZLILIK_TEXT } from "@/data/legal/gizlilik";

export default function GizlilikPage() {
  return <LegalDoc testid="gizlilik-page" title="Gizlilik Politikası" text={GIZLILIK_TEXT} />;
}
